/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InfantEarlyNeonatalPeriod,
    InfantEarlyNeonatalPeriodFromJSON,
    InfantEarlyNeonatalPeriodToJSON,
    InfantEarlyNeonatalPeriodPagination,
    InfantEarlyNeonatalPeriodPaginationFromJSON,
    InfantEarlyNeonatalPeriodPaginationToJSON,
} from '../models';

export interface AdminInfantEarlyNeonatalPeriodsIdGetRequest {
    id: number;
    userId?: number;
}

export interface InfantEarlyNeonatalPeriodsGetRequest {
    babyId: number;
    page?: number;
    itemsPerPage?: number;
    orderType?: string;
    orderBy?: string;
}

export interface InfantEarlyNeonatalPeriodsIdDeleteRequest {
    id: number;
}

export interface InfantEarlyNeonatalPeriodsIdGetRequest {
    id: number;
}

export interface InfantEarlyNeonatalPeriodsIdPutRequest {
    id: number;
    infantEarlyNeonatalPeriod?: InfantEarlyNeonatalPeriod;
}

export interface InfantEarlyNeonatalPeriodsPostRequest {
    infantEarlyNeonatalPeriod?: InfantEarlyNeonatalPeriod;
}

export interface InfantEarlyNeonatalPeriodsShareAllGetRequest {
    sourceUserId: number;
    babyId: number;
    page?: number;
    itemsPerPage?: number;
    orderType?: string;
    orderBy?: string;
}

export interface InfantEarlyNeonatalPeriodsShareDetailGetRequest {
    sourceUserId: number;
    recordId: number;
}

/**
 * 
 */
export class InfantEarlyNeonatalPeriodsApi extends runtime.BaseAPI {

    /**
     * 
     */
    adminInfantEarlyNeonatalPeriodsIdGetRaw = async (requestParameters: AdminInfantEarlyNeonatalPeriodsIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InfantEarlyNeonatalPeriod>> => {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling adminInfantEarlyNeonatalPeriodsIdGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/admin/infantEarlyNeonatalPeriods/:id`.replace(`${":id"}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InfantEarlyNeonatalPeriodFromJSON(jsonValue));
    }

    /**
     * 
     */
    adminInfantEarlyNeonatalPeriodsIdGet = async (requestParameters: AdminInfantEarlyNeonatalPeriodsIdGetRequest, initOverrides?: RequestInit): Promise<InfantEarlyNeonatalPeriod> => {
        const response = await this.adminInfantEarlyNeonatalPeriodsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    infantEarlyNeonatalPeriodsGetRaw = async (requestParameters: InfantEarlyNeonatalPeriodsGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InfantEarlyNeonatalPeriodPagination>> => {
        if (requestParameters.babyId === null || requestParameters.babyId === undefined) {
            throw new runtime.RequiredError('babyId','Required parameter requestParameters.babyId was null or undefined when calling infantEarlyNeonatalPeriodsGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.itemsPerPage !== undefined) {
            queryParameters['itemsPerPage'] = requestParameters.itemsPerPage;
        }

        if (requestParameters.orderType !== undefined) {
            queryParameters['orderType'] = requestParameters.orderType;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.babyId !== undefined) {
            queryParameters['babyId'] = requestParameters.babyId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/infantEarlyNeonatalPeriods`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InfantEarlyNeonatalPeriodPaginationFromJSON(jsonValue));
    }

    /**
     * 
     */
    infantEarlyNeonatalPeriodsGet = async (requestParameters: InfantEarlyNeonatalPeriodsGetRequest, initOverrides?: RequestInit): Promise<InfantEarlyNeonatalPeriodPagination> => {
        const response = await this.infantEarlyNeonatalPeriodsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    infantEarlyNeonatalPeriodsIdDeleteRaw = async (requestParameters: InfantEarlyNeonatalPeriodsIdDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<any>> => {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling infantEarlyNeonatalPeriodsIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/infantEarlyNeonatalPeriods/:id`.replace(`${":id"}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    infantEarlyNeonatalPeriodsIdDelete = async (requestParameters: InfantEarlyNeonatalPeriodsIdDeleteRequest, initOverrides?: RequestInit): Promise<any> => {
        const response = await this.infantEarlyNeonatalPeriodsIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    infantEarlyNeonatalPeriodsIdGetRaw = async (requestParameters: InfantEarlyNeonatalPeriodsIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InfantEarlyNeonatalPeriod>> => {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling infantEarlyNeonatalPeriodsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/infantEarlyNeonatalPeriods/:id`.replace(`${":id"}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InfantEarlyNeonatalPeriodFromJSON(jsonValue));
    }

    /**
     * 
     */
    infantEarlyNeonatalPeriodsIdGet = async (requestParameters: InfantEarlyNeonatalPeriodsIdGetRequest, initOverrides?: RequestInit): Promise<InfantEarlyNeonatalPeriod> => {
        const response = await this.infantEarlyNeonatalPeriodsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    infantEarlyNeonatalPeriodsIdPutRaw = async (requestParameters: InfantEarlyNeonatalPeriodsIdPutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InfantEarlyNeonatalPeriod>> => {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling infantEarlyNeonatalPeriodsIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/infantEarlyNeonatalPeriods/:id`.replace(`${":id"}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InfantEarlyNeonatalPeriodToJSON(requestParameters.infantEarlyNeonatalPeriod),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InfantEarlyNeonatalPeriodFromJSON(jsonValue));
    }

    /**
     */
    infantEarlyNeonatalPeriodsIdPut = async (requestParameters: InfantEarlyNeonatalPeriodsIdPutRequest, initOverrides?: RequestInit): Promise<InfantEarlyNeonatalPeriod> => {
        const response = await this.infantEarlyNeonatalPeriodsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    infantEarlyNeonatalPeriodsPostRaw = async (requestParameters: InfantEarlyNeonatalPeriodsPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InfantEarlyNeonatalPeriod>> => {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/infantEarlyNeonatalPeriods`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InfantEarlyNeonatalPeriodToJSON(requestParameters.infantEarlyNeonatalPeriod),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InfantEarlyNeonatalPeriodFromJSON(jsonValue));
    }

    /**
     */
    infantEarlyNeonatalPeriodsPost = async (requestParameters: InfantEarlyNeonatalPeriodsPostRequest = {}, initOverrides?: RequestInit): Promise<InfantEarlyNeonatalPeriod> => {
        const response = await this.infantEarlyNeonatalPeriodsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    infantEarlyNeonatalPeriodsShareAllGetRaw = async (requestParameters: InfantEarlyNeonatalPeriodsShareAllGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InfantEarlyNeonatalPeriodPagination>> => {
        if (requestParameters.sourceUserId === null || requestParameters.sourceUserId === undefined) {
            throw new runtime.RequiredError('sourceUserId','Required parameter requestParameters.sourceUserId was null or undefined when calling infantEarlyNeonatalPeriodsShareAllGet.');
        }

        if (requestParameters.babyId === null || requestParameters.babyId === undefined) {
            throw new runtime.RequiredError('babyId','Required parameter requestParameters.babyId was null or undefined when calling infantEarlyNeonatalPeriodsShareAllGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.itemsPerPage !== undefined) {
            queryParameters['itemsPerPage'] = requestParameters.itemsPerPage;
        }

        if (requestParameters.orderType !== undefined) {
            queryParameters['orderType'] = requestParameters.orderType;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.sourceUserId !== undefined) {
            queryParameters['sourceUserId'] = requestParameters.sourceUserId;
        }

        if (requestParameters.babyId !== undefined) {
            queryParameters['babyId'] = requestParameters.babyId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/infantEarlyNeonatalPeriods/share/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InfantEarlyNeonatalPeriodPaginationFromJSON(jsonValue));
    }

    /**
     * 
     */
    infantEarlyNeonatalPeriodsShareAllGet = async (requestParameters: InfantEarlyNeonatalPeriodsShareAllGetRequest, initOverrides?: RequestInit): Promise<InfantEarlyNeonatalPeriodPagination> => {
        const response = await this.infantEarlyNeonatalPeriodsShareAllGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    infantEarlyNeonatalPeriodsShareDetailGetRaw = async (requestParameters: InfantEarlyNeonatalPeriodsShareDetailGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InfantEarlyNeonatalPeriod>> => {
        if (requestParameters.sourceUserId === null || requestParameters.sourceUserId === undefined) {
            throw new runtime.RequiredError('sourceUserId','Required parameter requestParameters.sourceUserId was null or undefined when calling infantEarlyNeonatalPeriodsShareDetailGet.');
        }

        if (requestParameters.recordId === null || requestParameters.recordId === undefined) {
            throw new runtime.RequiredError('recordId','Required parameter requestParameters.recordId was null or undefined when calling infantEarlyNeonatalPeriodsShareDetailGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.sourceUserId !== undefined) {
            queryParameters['sourceUserId'] = requestParameters.sourceUserId;
        }

        if (requestParameters.recordId !== undefined) {
            queryParameters['recordId'] = requestParameters.recordId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/infantEarlyNeonatalPeriods/share/detail`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InfantEarlyNeonatalPeriodFromJSON(jsonValue));
    }

    /**
     * 
     */
    infantEarlyNeonatalPeriodsShareDetailGet = async (requestParameters: InfantEarlyNeonatalPeriodsShareDetailGetRequest, initOverrides?: RequestInit): Promise<InfantEarlyNeonatalPeriod> => {
        const response = await this.infantEarlyNeonatalPeriodsShareDetailGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
